import { useEffect } from 'react';
import { styled } from '@mui/material';

import type { DataGridProps } from '@/components/ReactDataGrid';
import { DataGrid } from '@/components/ReactDataGrid';

import type { UseFieldMatchingFileUploadConfig } from './useFieldMatchingFileUpload';
import { useFieldMatchingFileUpload } from './useFieldMatchingFileUpload';

export type FieldMatchingGridProps = DataGridProps & {
  numberOfColumnsFromSettings: UseFieldMatchingFileUploadConfig['numberOfColumnsFromSettings'];
  onUpload: UseFieldMatchingFileUploadConfig['onUpload'];
  uploadedFile: File | null;
  renderGridOption: UseFieldMatchingFileUploadConfig['renderGridOption'];
};

const StyledDataGrid = styled(DataGrid)({
  '& .InovuaReactDataGrid__locked-row-cell': {
    height: '40px !important',
  },
});

export const renderGridHeader = (columnNumber: number) => `${columnNumber} колонка`;

export const FieldMatchingGrid = (props: FieldMatchingGridProps) => {
  const { numberOfColumnsFromSettings, onUpload, uploadedFile, renderGridOption, ...restOfGridProps } = props;

  const { parseUploadedFile } = useFieldMatchingFileUpload({
    numberOfColumnsFromSettings,
    renderGridHeader,
    renderGridOption,
    onUpload,
  });

  useEffect(() => {
    if (uploadedFile) {
      parseUploadedFile([uploadedFile]);
    }
    /* eslint-disable-next-line */
  }, [uploadedFile]);

  return <StyledDataGrid sortable={false} enableSelection={false} {...restOfGridProps} />;
};
